import * as React from 'react';
const CongestioneNasaleIcon = ({ primaryColor, secondaryColor, width }) => {
  const strokePrimary = primaryColor || '#282828';
  const strokeSecondary = secondaryColor || '#ffcf38';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Livello_2"
      data-name="Livello 2"
      viewBox="0 0 200 200"
      style={{ width }}
    >
      <defs>
        <style>
          {`.cls-1,.cls-2{stroke:${strokeSecondary};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.cls-2{stroke:${strokePrimary}}`}
        </style>
      </defs>
      <path
        d="M90.53 84.26c1.07 16.53-2.73 21-8.2 30.23-4.13 6.97-2.69 13.11 6 12.2M109.47 84.26c-1.07 16.53 2.73 21 8.2 30.23 4.13 6.97 2.69 13.11-6 12.2"
        className="cls-2"
      />
      <path
        d="M114.8 121.6c-4.74-1.14-7.38 2-8.74 3.68-1.98 2.44-3.89 3.65-6.08 3.65h.05c-2.19 0-4.1-1.21-6.08-3.65-1.36-1.68-4-4.82-8.74-3.68"
        className="cls-2"
      />
      <path
        d="M75.54 98.35c-4.02 0-6.78-.06-12.41-1.37-7.19-1.68-11 6.77-6.86 11.57 3.12 3.61 4.13 4.64 5.87 9.74 1.82 5.33 8.54 5.12 10.07-.18 1.45-5.02 1.85-7.19 5.83-11.83 2.94-3.42 2.38-7.94-2.5-7.93ZM124.46 98.35c4.02 0 6.78-.06 12.41-1.37 7.19-1.68 11 6.77 6.86 11.57-3.12 3.61-4.13 4.64-5.87 9.74-1.82 5.33-8.54 5.12-10.07-.18-1.45-5.02-1.85-7.19-5.83-11.83-2.94-3.42-2.38-7.94 2.5-7.93ZM89.26 73.21c-2.52-9.89-12.88-6.62-16.26-4.09-3.35 2.51-3.12 6.25.73 6.21 3.1-.04 6.92.12 11.1 2.23 3.23 1.63 5.51-.11 4.43-4.35ZM110.74 73.21c2.52-9.89 12.88-6.62 16.26-4.09 3.35 2.51 3.12 6.25-.73 6.21-3.1-.04-6.92.12-11.1 2.23-3.23 1.63-5.51-.11-4.43-4.35Z"
        className="cls-1"
      />
    </svg>
  );
};
export default CongestioneNasaleIcon;
